var scope_0 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/03c3d4d1477c07192c2c60f98f54798c.js').default;
var scope_1 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/03d36a3b0375f03886c95537587df70b.js').default;
var scope_2 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f7beaf23187ef8ec098844d0e33c5fd.js').default;
var scope_3 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/23bf787cda5de20b7534e38bfeea1bfc.js').default;
var scope_4 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2d8a378832c2a6edf31cb4575e550dfe.js').default;
var scope_5 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/56ac21629222483bd6be77fc6b589e8a.js').default;
var scope_6 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82edb686bc182b2daf00e6bc712a7e60.js').default;
var scope_7 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/840a4497e422d0289e1abd96b759b43b.js').default;
var scope_8 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ee59d057281d60ac4a7e0b6b277313b.js').default;
var scope_9 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ab8ef0e0c83295263e2bf6d04141b33e.js').default;
var scope_10 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aef101d959b26dfb2d4fb7caf98bad12.js').default;
var scope_11 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ffcca714cc1d14db4628ae3ae3427a3a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11 )
    